import { render, staticRenderFns } from "./LeaderboardAwardWinnersChart.vue?vue&type=template&id=56d57539"
import script from "./LeaderboardAwardWinnersChart.vue?vue&type=script&lang=js"
export * from "./LeaderboardAwardWinnersChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default})
